import React from 'react';

const SvgLayers = ({ title, ...props }) => (
  <svg aria-label={title} viewBox="0 0 24 24" {...props}>
    {title ? <title>{title}</title> : null}
    <path d="M12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27M12 18.54l-7.38-5.73L3 14.07l9 7 9-7-1.63-1.27L12 18.54z" />
  </svg>
);

export default SvgLayers;
